
export interface IUserLoginModel {
    Login: string;
    CompanyId: number;
    IsMasterActive: boolean;

    ToJson: () => string;
}

export default class UserLoginModel implements IUserLoginModel {
    Login: string;
    CompanyId: number;
    IsMasterActive: boolean;

    constructor(login: string, companyId: number, activateMaster = false) {

        if (!login)
            throw new Error("Favor informar o Login !!");

        if (!companyId)
            throw new Error("Favor selecionar uma Empresa !!");

        this.Login = login;
        this.CompanyId = companyId;
        this.IsMasterActive = activateMaster
    }

    ToJson = (): string => {

        const dto = {
            login: this.Login,
            companyId: this.CompanyId,
            isMaster: this.IsMasterActive
        },
            result = JSON.stringify(dto);

        return result;
    };
}